import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyC1qLNDRa3NYrcqxQAP2vamcOlBfaBsxaY",
  authDomain: "linkedin-tools-growleads.firebaseapp.com",
  projectId: "linkedin-tools-growleads",
  storageBucket: "linkedin-tools-growleads.firebasestorage.app",
  messagingSenderId: "40053416092",
  appId: "1:40053416092:web:94756429106afe5f740d59",
  measurementId: "G-WD9L4M6CEV"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
